import {db} from "@/firebase/init";
import _ from 'lodash';
export default {
    computed: {
    },
    data() {
        return {
            beforeUpdate: {},
            afterUpdate: {},
        };
    },
    methods: {
        async fetchHostingAccountDetails(id){
            try{
                const accountRef = await db.collection('hostingAccounts').doc(id).get()
                const {accounts} = accountRef.data();
                return accounts
            }
           catch(e){
                console.log(e.toString(), 'Occured in fetching hosting account details')
                return false
           }
        },
        async addHostingAccountEventLog(data) {
            return
            try {
                const {action, afterPayload, hostingAccountId } = data;
                let {beforePayload} = data;
                console.log('these actions', action, afterPayload, hostingAccountId, beforePayload )
                if(beforePayload === false){
                    beforePayload = await this.fetchHostingAccountDetails(hostingAccountId)
                    console.log('Fetched hosting account details for hosting logs ', beforePayload)
                }
                const location = 'WPO-Admin'
                const newEvent = {
                    action,
                    beforePayload : beforePayload,
                    afterPayload: afterPayload ,
                    location,
                    createdAt: new Date().toISOString(),
                    actionBy: `${this.user.firstName} ${this.user.lastName}`
                }
                let events = []
                const currentMonth = new Date().getMonth() + 1;
                const currentYear = new Date().getFullYear();
                const hostingAccountLogRef = await db.collection('hostingAccountsLog').where('month', '==', currentMonth).where('year', '==', currentYear).where('uid', '==', hostingAccountId).limit(1).get();
                if (hostingAccountLogRef.size) {
                    const data = { id: hostingAccountLogRef.docs[0].id, ...hostingAccountLogRef.docs[0].data() };
                    events = data.events;
                    events.push(newEvent)
                    await db.collection('hostingAccountsLog').doc(hostingAccountId).update({
                        events
                    })
                    console.log('New Hosting account log updated')
                } else {
                    events.push(newEvent)
                    await db.collection('hostingAccountsLog').add({
                        events,
                        uid: hostingAccountId,
                        month: currentMonth,
                        year: currentYear,
                    })

                    console.log('New Hosting account log added')
                }
            }
            catch(e){
                console.log(e.toString(), 'Occurred while adding hosting accounts logs')
            }

        },
    }
}